// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"913":"dc166239","6093":"9dfe302d"}[chunkId] + ".css";
};